module.exports = __webpack_public_path__ + "img/benidorm.5d6b1f5b.jpg";